import { library } from "@fortawesome/fontawesome-svg-core";
import { faBars, faUser, faWindowClose } from "@fortawesome/free-solid-svg-icons";
import React, { Component, Suspense } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { getToken, validToken } from "./actions/user";
import "./App.css";
import Layout from "./components/Layout";
import LoadPage from "./components/Load/LoadPage";
import Routers from "./Routers";
import { createTheme, ThemeProvider } from "@mui/material/styles";

import { NotificationProvider } from "./contexts/NotificationsContext";
import { SnackbarProvider, useSnackbar } from 'notistack';


library.add(faBars, faWindowClose, faUser);

const actions = {
  getToken,
};

const theme = createTheme({
  typography: {
    fontFamily: "Montserrat, Arial, sans-serif",
  },
});

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadPage: true,
      token: null,
      tokenLoaded: false
    };
  }

  componentWillMount() {
    //detect change url
    this.unlisten = this.props.history.listen((location, action) => {
      window.scroll(0, 0);
      window.dataLayer.push({
        event: "VirtualPageview",
        virtualPageURL: location.pathname,
      });
    });
  }

  componentDidMount() {

    document.body.style.zoom = '90%';
    window.dataLayer = window.dataLayer || [];
    this.validateToken()
  }

  validateToken() {
    const token = localStorage.getItem("KarbonoaTOKEN");
    
    if (token) {
      validToken({ token }).then((response) => {
        if (response.status === 1 && response.valid === true) {
          this.props.getToken(token);
          return this.setState({
              token: token,             
              tokenLoaded: true,
              loadPage: false      
            });
        }
        localStorage.removeItem("KarbonoaTOKEN");
        this.props.getToken(null);
        return this.props.history.push("/login");
      });
    }else {
      return this.setState({          
          tokenLoaded: true,
          loadPage: false       
        });
    }
  }

  render() {

    const { token } = this.props;
    const { tokenLoaded } = this.state
    
    if (!tokenLoaded) {
      return <LoadPage load={true}/> ;
    }

    return (
      <Suspense fallback={<Loader />}>
        <ThemeProvider theme={theme}>
        <div className="App">
          {!this.state.loadPage && (
            <Layout {...this.props} >
              <Routers token={token} />
            </Layout>
          )}
        </div>
        </ThemeProvider>
      </Suspense>
    );
  }
}

const mapDispatchToProps = (dispatch) => bindActionCreators(actions, dispatch);
const mapStateToProps = ({ user }) => ({
  token: user.token,
});

const Loader = () => <LoadPage load />;
const AppTRa = withTranslation()(withRouter(connect(mapStateToProps, mapDispatchToProps)(App)));
function AppT() {
  return (
    <Suspense fallback={<Loader />}>
      <NotificationProvider>
        <SnackbarProvider maxSnack={7}>
          <AppTRa />
        </SnackbarProvider>
      </NotificationProvider>
    </Suspense>
  );
}

export default AppT;
